import { getJoinedGroupsUserWall } from '../../../../apis/tms/feed.api';
import { middlewarePostOfUserWall } from '../../../../apis/tms/post.api';
import {
  FEED_LIST_PERSONAL_USER_WALL,
  USER_JOINED_GROUPS_USER_WALL,
} from '../../../../constant/QueryKeyName';
import { USER_WALL_GROUP_PAGE_SIZE } from '../../../../constant/group';
import { GROUP_POST_PAGE_SIZE } from '../../../../constant/numericParams';
import useGetTMSUserIdByEmail from '../../../../hooks/useGetTMSUserIdByEmail';
import { TPostInfinityQuery } from '../../../../interfaces/post.interface';
import { GroupSuggestionActionEnum } from '../../../../interfaces/training.interface';
import { CreatePostButtonDesktop } from '../../../buttons/CreatePostButton';
import CreatePostInput from '../../../input/PostInput';
import EmptyScreen from '../../EmptyScreen';
import GroupSuggestionSwiper from '../../feed/group-suggestion';
import PostFeedWithInfinityQuery from '../../feed/post';

interface IFeedTab {
  isOwnerProfile: boolean;
  email: string;
  userId: string;
  fullName: string;
}

const FeedTab = ({ isOwnerProfile, email, fullName }: IFeedTab) => {
  const {
    queryReturn: { data: tmsUserID },
  } = useGetTMSUserIdByEmail(email);

  return (
    <div className="flex w-full">
      <div className="flex w-full flex-col-reverse items-center xl:flex-row xl:items-start xl:justify-center">
        <div className="flex w-full max-w-[524px] flex-1 flex-col items-center justify-center md:w-full xl:w-auto">
          <div className="mx-4 mb-2 mt-6 flex w-full max-w-[100vw] flex-1 justify-center p-[0px_16px] sm:max-w-[524px]">
            {isOwnerProfile && <CreatePostInput />}
          </div>
          <PostFeedWithInfinityQuery
            queryFn={middlewarePostOfUserWall}
            queryKey={[
              FEED_LIST_PERSONAL_USER_WALL,
              tmsUserID as string,
              GROUP_POST_PAGE_SIZE,
            ]}
            opt={{
              enabled: !!tmsUserID,
              refetchOnMount: false,
              refetchOnWindowFocus: false,
              keepPreviousData: true,
              cacheTime: 0,
              getNextPageParam: (
                _lastPage: TPostInfinityQuery,
                _allPages: TPostInfinityQuery[]
              ) => {
                return _lastPage?.hasNextPage
                  ? _lastPage?.currentPage + 1
                  : undefined;
              },
            }}
            emptyScreen={
              <EmptyScreen
                description={`${
                  isOwnerProfile ? 'Bạn' : 'Người dùng này'
                } chưa tạo bài viết nào`}
                addNew={
                  isOwnerProfile ? <CreatePostButtonDesktop /> : undefined
                }
              />
            }
          />
        </div>
        <div className="md:max-w-[100vw] xl:sticky xl:top-[120px] xl:h-[80dvh] xl:overflow-y-scroll">
          <GroupSuggestionSwiper
            title={
              isOwnerProfile
                ? 'Cộng đồng bạn tham gia'
                : 'Cộng đồng có ' + fullName.split(' ').pop()
            }
            fetchFunction={getJoinedGroupsUserWall}
            queryKey={
              tmsUserID
                ? [
                    USER_JOINED_GROUPS_USER_WALL,
                    tmsUserID as string,
                    USER_WALL_GROUP_PAGE_SIZE,
                  ]
                : []
            }
            action={
              isOwnerProfile
                ? GroupSuggestionActionEnum.ShowRole
                : GroupSuggestionActionEnum.JoinGroup
            }
          />
        </div>
      </div>
    </div>
  );
};

export default FeedTab;
